module.exports = __webpack_public_path__ + "static/media/atm.390eea71.svg";